// import { PhoneNumber } from "libphonenumber-js";

interface State {
  isValid(phone: string, phoneRegion?: string): boolean;
  format(phone: string, phoneRegion?: string): string;
  // change any to type PhoneNumber
  parse(phone: string, phoneRegion?: string): any | undefined;
}

export interface PhoneHandler {
  isValid(phoneNumber: string, phoneRegion?: string): boolean;
  format(phoneNumber: string, phoneRegion?: string): string;
  parse(phoneNumber: string, phoneRegion?: string): any | undefined;
}

export class PhoneHandlerGoogle implements PhoneHandler {
  private static instance?: PhoneHandlerGoogle;
  private state: State;

  private constructor(state: State) {
    this.state = state;
  }

  public static async getInstance(): Promise<PhoneHandlerGoogle> {
    if (!PhoneHandlerGoogle.instance) {
      return import("libphonenumber-js").then(
        ({ isValidPhoneNumber, AsYouType, isSupportedCountry, parsePhoneNumber }) => {
          const instance = new PhoneHandlerGoogle({
            isValid: (phoneNumber: string, phoneRegion?: string) => {
              if (!phoneRegion) {
                return isValidPhoneNumber(phoneNumber);
              }
              const isValidRegion = isSupportedCountry(phoneRegion);
              return isValidRegion ? isValidPhoneNumber(phoneNumber, phoneRegion) : false;
            },
            format: (phoneNumber: string, phoneRegion?: string) => {
              if (!phoneRegion) {
                return new AsYouType().input(phoneNumber);
              }

              const isValidRegion = isSupportedCountry(phoneRegion);
              return isValidRegion ? new AsYouType(phoneRegion).input(phoneNumber) : phoneNumber;
            },
            parse: (phoneNumber: string, phoneRegion?: string) => {
              if (!phoneRegion) {
                return parsePhoneNumber(phoneNumber);
              }

              const isValidRegion = isSupportedCountry(phoneRegion);
              return isValidRegion ? parsePhoneNumber(phoneNumber, phoneRegion) : undefined;
            }
          });

          return instance;
        }
      );
    }

    return PhoneHandlerGoogle.instance;
  }

  public isValid(phone: string, phoneRegion?: string): boolean {
    return this.state.isValid(phone, phoneRegion);
  }

  public format(phone: string, phoneRegion?: string): string {
    return this.state.format(phone, phoneRegion);
  }

  public parse(phone: string, phoneRegion?: string): any | undefined {
    return this.state.parse(phone, phoneRegion);
  }
}
